import { Component, OnInit } from '@angular/core';

import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { GerinusService } from 'src/app/app-core/lib/gerinus.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { UploadService } from 'src/app/app-core/services/upload.service';

import Swal from 'sweetalert2';
import { userGroupChangeEnum } from 'src/app/Enums/userEnum';
import { IPerfilDisponivel, UsersGroupEnum } from 'src/app/app-core/services/user.service';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    providers: [GlobalService, GerinusService, UserService, UploadService],
})
export class UserProfileComponent extends GerinusBD implements OnInit {
    constructor(
        public service: GerinusService,
        public global: GlobalService,
        public userService: UserService,
        public uploadService: UploadService
    ) {
        super(global, userService);
        this.add();
    }

    public swal = Swal;
    public modalImageName: string = 'image-upload';
    public modalPhoneName: string = 'edit-phonenumber';
    public userPhoneNumber: string = '';
    public mimeTypes: string[] = ['image/jpeg', 'image/png'];
    public formattedGroupName: string = this.userService.formatGroupName();


    ngOnInit() {
        document.querySelector('title').text = 'Meu Perfil';

        this.userPhoneNumber = this.global.user().PE_Telefone1;

        this.carregarPerfis();

        const user = this.global.user();
        if (user.USR_UsuarioInterno && user.USR_Status === 0 && !this.userService.isCidadao()) {
            this.userService.toggleToSecondaryUserGroup(user.USR_CodigoUsuario, userGroupChangeEnum.SECONDARY)
                .subscribe({
                    next: (response: any) => {
                        const updatedUser = {
                            ...user,
                            USG_CodigoGrupo: response.data.USG_CodigoGrupo,
                            USG_CodigoGrupoOriginal: response.data.USG_CodigoGrupoOriginal,
                            USR_Administrador: response.data.USR_Administrador,
                            GRP_CodigoGrupo: response.data.GRP_CodigoGrupo,
                            GRP_Descricao: response.data.GRP_Descricao,
                            USR_LembrarEscolha: response.data.USR_LembrarEscolha,
                            USR_UsuarioInterno: false
                        };

                        localStorage.setItem('user', JSON.stringify(updatedUser));
                        window.location.reload();
                    },
                    error: (err) => {
                        console.error('Erro ao alternar para cidadão automaticamente:', err);
                    }
                });
        }

    }

    public defaults() {
        return {
            USR_CodigoUsuario: this.global.user().USR_CodigoUsuario,
            usuario: {
                USR_Foto: '',
            },
        };
    }

    public getUploadedFile(event: any) {
        this.entity.usuario.USR_Foto = event.file.url;
        this.save();
    }

    public onDeleteFileUploaded(event: any) {
        if (this.entity.file && this.entity.file.length > event.index) {
            this.entity.file.splice(event.index, 1);
        }
    }

    public async save() {
        this.userService.save(this.entity).subscribe({
            next: async () => {
                let userSaved = this.global.user();
                userSaved.USR_Foto = await this.getImageUrl(this.entity.usuario.USR_Foto);

                localStorage.setItem('user', JSON.stringify(userSaved));
                this.global.closeModalInfo(this.modalImageName);
                this.global.swal.fire({
                    title: 'Foto atualizada com sucesso!',
                    icon: 'success',
                })
            }
        });
    }

    public savePhonenumber() {
        const user = this.global.user();
        const telefone = (this.userPhoneNumber ?? '').replace(/\D/g, '');

        if (telefone.length < 10) {
            this.global.swal.fire({
                title: 'Informe um telefone válido',
                icon: 'warning',
            });
            return;
        }

        this.global.startLoading();

        this.userService.updateMyPhone(telefone).subscribe({
            next: (response: any) => {
                this.global.stopLoading();

                localStorage.setItem('user', JSON.stringify({ ...user, PE_Telefone1: response.PE_Telefone1 }));

                this.global.closeModalInfo(this.modalPhoneName);
                this.global.swal.fire({
                    title: 'Número atualizado com sucesso',
                    icon: 'success',
                });
            },
            error: (erro: any) => {
                this.global.stopLoading();
                this.global.swal.fire({
                    title: 'Não foi possível atualizar o número',
                    text: erro?.error?.message ?? 'Tente novamente mais tarde.',
                    icon: 'error',
                });
            },
        });
    }

    /**
     * Perfis que a pessoa realmente possui, conferidos contra o cadastro atual.
     *
     * Deixou de ser getter de propósito: além de consultar a API uma vez em vez de a cada
     * ciclo de change detection, exibir só o que o servidor aceita depende de dados frescos —
     * o retrato do login não acompanha mudanças feitas por um administrador depois.
     */
    public perfis: IPerfilDisponivel[] = [];

    /**
     * Enquanto a lista não chega, a seção inteira sumia da tela e dava impressão de travamento.
     * Com este sinalizador o bloco aparece de imediato, indicando que os perfis estão vindo.
     */
    public carregandoPerfis: boolean = true;

    private carregarPerfis() {
        this.carregandoPerfis = true;

        this.userService.perfisDisponiveisAtualizados().subscribe({
            next: (perfis) => {
                this.perfis = perfis;
                this.carregandoPerfis = false;
            },
            error: () => {
                this.carregandoPerfis = false;
            },
        });
    }

    /**
     * Encaminha para o endpoint certo conforme o destino escolhido. O servidor revalida
     * tudo de novo; esta escolha é só de roteamento da chamada.
     */
    public alternarPara(perfil: IPerfilDisponivel) {
        // Guarda única para os dois caminhos abaixo: sem ela, cliques repetidos disparavam uma
        // troca por clique, cada uma com seu aviso na tela.
        if (this.userService.trocandoPerfil) {
            return;
        }

        const usuario = this.global.user();

        // As colunas de grupo voltam do banco ora como número, ora como string. Com `===` cru,
        // o roteamento caía no ramo errado e a chamada ia para o endpoint que não correspondia
        // ao botão clicado.
        const primario = Number(usuario.USG_CodigoGrupoPrimario);
        const secundario = Number(usuario.USG_CodigoGrupoSecundario);

        if (perfil.id === UsersGroupEnum.CITIZEN) {
            this.handleChangeGroup();
            return;
        }

        if (perfil.id === secundario) {
            this.toggleChangeToSecondaryUserGroup(userGroupChangeEnum.SECONDARY);
            return;
        }

        if (perfil.id === primario) {
            this.toggleChangeToSecondaryUserGroup(userGroupChangeEnum.PRIMARY);
            return;
        }

        // Cadastro legado (sem primário e sem secundário): o retorno do perfil de cidadão
        // é resolvido pelo servidor a partir do grupo original.
        this.handleChangeGroup();
    }

    handleChangeGroup() {
        this.userService.handleChangeInternalUserGroup(this.global.user().USR_LembrarEscolha);
    }

    async getImageUrl(imageName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.uploadService.download(imageName).subscribe({
                next: (response: any) => {
                    resolve(response.url);
                },
                error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    toggleChangeToSecondaryUserGroup(groupChange: number) {
        const userId = this.global.user().USR_CodigoUsuario;

        this.userService.trocandoPerfil = true;

        this.userService.toggleToSecondaryUserGroup(userId, groupChange).subscribe({
            next: (response: any) => {
                // Segue bloqueado: `aplicarTrocaLocal` navega e a tela é remontada.
                this.userService.aplicarTrocaLocal(response.data);
            },
            error: (erro: any) => {
                this.userService.trocandoPerfil = false;

                // Num HttpErrorResponse a mensagem da API fica em `error.message`; `erro.message`
                // é o texto genérico do Angular. Recusas legítimas do servidor — como
                // "Este perfil não está vinculado ao seu usuário" — não chegavam ao usuário.
                Swal.fire({
                    title: 'Não foi possível alternar',
                    text: erro?.error?.message ?? 'Tente novamente mais tarde.',
                    icon: 'warning',
                });

                // O cadastro mudou por baixo da tela: recarrega a lista para parar de oferecer
                // um perfil que o servidor acabou de recusar.
                this.carregarPerfis();
            },
        });
    }

    public get isCitizen(): boolean {
        return this.userService.isCidadao();
    }

    public get isInternalUserActive(): boolean {
        return this.global.user().USR_UsuarioInterno && this.global.user().USR_Status === 1;
    }

    // changePrimaryGroupRule/changeSecondaryGroupRule foram removidos: a decisão de quais
    // perfis exibir passou para perfisDisponiveis(), no UserService, compartilhado com a
    // dashboard. Ambos dependiam de USG_CodigoGrupoOriginal, que é histórico e não permissão.
}